import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './customPageHeaderView.module.css';

export const CustomPageHeaderView = ({ isProviderMode, headerContent, backgroundColor }) => (
  <header
    className={cx(styles.root, isProviderMode ? styles.providerRoot : styles.nonProviderRoot)}
    style={{ backgroundColor }}
  >
    {headerContent}
  </header>
);

CustomPageHeaderView.propTypes = {
  headerContent: PropTypes.node,
  backgroundColor: PropTypes.string,
  isProviderMode: PropTypes.bool.isRequired,
};
